import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Button, Avatar, Typography } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import ReuseAction from "components/common/ReuseAction";

import inviteActions from "./actions";
import { useSelector } from "react-redux";
import { INVITE_PROP } from "./constants";
import { UserRoleText } from "components/User/constants";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  box: {
    margin: theme.spacing(1),
  },
  bold: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  AvatarSmall: {
    marginRight: theme.spacing(2),
  },
  popoverItemDelete: {
    color: "#E16B66",
  },
}), { index: 999 });

const TableActions = () => {
  const classes = useStyles();
  const { deleteInvite, resendInvite } = inviteActions();
  const { editInvite } = useSelector((state) => state.invites);

  const deleteInvitation = () => {
    deleteInvite();
  };

  const resendInvitation = () => {
    resendInvite();
  };
  const getActions = () => (
    <Box m={1}>
      <Grid container direction="column">
        <Button
          size="large"
          onClick={() => {
            resendInvitation();
          }}
          className={classes.popoverItem}
        >
          Resend Invite
        </Button>
        <Button
          size="large"
          color="secondary"
          onClick={() => deleteInvitation()}
          className={classes.popoverItemDelete}
        >
          Cancel Invitation
        </Button>
      </Grid>
    </Box>
  );
  const getMobileContent = () =>
    editInvite[INVITE_PROP.EMAIL] && (
      <Box p={3}>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Avatar className={classes.AvatarSmall}>
              <EmailIcon />
            </Avatar>
            <Typography variant="h5">
              {editInvite[INVITE_PROP.EMAIL]}
            </Typography>
          </Grid>
        </Box>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Typography className={classes.bold} variant="subtitle1">
              {"Role:"}
            </Typography>
            <Typography variant="subtitle1">
              {UserRoleText[editInvite[INVITE_PROP.ROLE]]}
            </Typography>
          </Grid>
        </Box>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Typography className={classes.bold} variant="subtitle1">
              {"Status:"}
            </Typography>
            <Typography variant="subtitle1">
              {editInvite[INVITE_PROP.STATUS]}
            </Typography>
          </Grid>
        </Box>
        <Box m={2}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
            direction="row"
          >
            <Typography className={classes.bold} variant="subtitle1">
              {"Expire On:"}
            </Typography>
            <Typography variant="subtitle1">
              {moment(editInvite[INVITE_PROP.EXPIRY_DATE]).format(
                "MMM, DD YYYY"
              )}
            </Typography>
          </Grid>
        </Box>
      </Box>
    );
  return (
    <ReuseAction actions={getActions()} mobileContent={getMobileContent()} />
  );
};

export default TableActions;
